import React, {useEffect, useState} from 'react';
import {ErrorBox} from '../errorbox/errorbox';
import i18n from '../../utilities/i18n';
import './snartsluttadvarsel.scss';

const JANUARY = 0;
const APRIL = 3;

const SnartSluttAdvarsel = (props) => {
  const [typeAdvarsel, setTypeAdvarsel] = useState('');
  const [jaktaarDeler, setJaktaarDeler] = useState([]);

  useEffect(() => {
    if (props.jaktaar) {
      const today = new Date();
      const isEndingThisYear = today.getFullYear().toString() === props.jaktaar.split('/')[1];
      const currentMonth = today.getMonth();

      setJaktaarDeler(props.jaktaar.split('/'));
      if (isEndingThisYear && (currentMonth <= APRIL)) {
        if (currentMonth === JANUARY) {
          setTypeAdvarsel ('mild');
        } else {
          setTypeAdvarsel('streng');
        }
      }
    }
  }, [props.jaktaar]);
  return (
    <section className='snartSlutt'>
      {typeAdvarsel === 'mild' &&
      <ErrorBox>
        <p className='mild'>
          {i18n.t('warning:betalingenGjelderForJaktaareet') + ' '}
          {props.jaktaar}
          {' '}
          (01.04.
          {jaktaarDeler[0]}
          -31.03.
          {jaktaarDeler[1]})
        </p>
      </ErrorBox>}
      {typeAdvarsel === 'streng' &&
      <ErrorBox>
        <h3 className='snartTitle'>{i18n.t('warning:jaktaaretErSnartslutt')}</h3>
        <p className='advarselTekst'>{i18n.t('warning:strengAdvarselGammeltJaktaarSnartSlutt').replace('JAKTAAR', props.jaktaar)}</p>
        <p className='advarselTekst'>{i18n.t('warning:strengAdvarselGammeltJaktaarSkalDuJakte')}</p>
      </ErrorBox>}
    </section>

  );
};
export default SnartSluttAdvarsel;
